import * as yup from 'yup';

const seasonSchema = yup.object().shape({
  type: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  startDate: yup.date().required('common.required'),
});

export default seasonSchema;
